module.exports = __webpack_public_path__ + "static/media/long_modal_bottom_rectangle.f44c793a.svg";